import imagePath from '../assets/webP/glasses.webp';

export const spotlight = {
  "title": "In oktober blaast onze wijnspeciaalzaak in Vichte 15 kaarsen uit !",
  "imagePath": imagePath
};
